/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CardActions from './CardActions/CardActions';
import CardContextProvider from './CardContext';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 3px 0px rgba(63,63,68,.15)',
  },
  icon: {
    margin: '0 2rem',
  },
  table: {
    border: 'none',
    '& td': {
      overflowWrap: 'anywhere',
      maxWidth: '2.5rem',
    },
    '& tbody td': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& th, & td': {
      border: 'none',
      background: 'transparent',
    },
    '& th:nth-child(1)': {
      width: '7%',
    },
    '& th:nth-child(2)': {
      width: '20%',
    },
    '& th:nth-child(3)': {
      width: '30%',
    },
    '& th:nth-child(4)': {
      width: '20%',
    },
  },
  actions: {
    margin: '0 1rem',
  },
});

export default function SummaryMinicard({
  Icon,
  sequenceNumber,
  entries,
  actionType,
  handleCardClick,
  handleClick,
  handleEdit,
  handleDelete,
  handleClose,
  anchorEl,
  isSelected,
  readOnly = false,
  id,
  className,
  actions,
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <CardContextProvider
      classes={classes}
      entries={entries}
      readOnly={readOnly}
      actionType={actionType}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      handleClick={handleClick}
      anchorEl={anchorEl}
      handleClose={handleClose}
      actions={actions}
    >
      <Card
        key={sequenceNumber}
        className={clsx(
          classes.root,
          className,
          isSelected && classes.cardSelected,
          handleCardClick && classes.cardSelectable,
        )}
        onClick={handleCardClick}
        id={id}
      >
        <div className={classes.icon}>
          <Icon />
        </div>
        <Table size="small" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell key={0} variant="head">
                {t('parties.minicard.sequence.number')}
              </TableCell>
              {entries.map(
                (entry, index) =>
                  entry.type !== 'cardViewDetail' && (
                    <TableCell key={index + 1} variant="head">
                      {entry.title}
                    </TableCell>
                  ),
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell key={0} variant="body">
                {sequenceNumber}
              </TableCell>
              {entries.map(
                (entry, index) =>
                  entry.type !== 'cardViewDetail' && (
                    <TableCell key={index + 1} variant="body">
                      {entry.value}
                    </TableCell>
                  ),
              )}
            </TableRow>
          </TableBody>
        </Table>
        <div className={classes.actions}>
          <CardActions id={id} />
        </div>
      </Card>
    </CardContextProvider>
  );
}
